var React = require('react');

function SDCSearch22N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m20.34082,19.28021l-5.41894-5.41876c2.58993-3.17565,2.11511-7.84958-1.06055-10.43951C10.68568.83202,6.01176,1.30684,3.42183,4.48249c-2.58993,3.17565-2.11511,7.84958,1.06055,10.43951,2.72993,2.22642,6.64902,2.22642,9.37896,0l5.41894,5.41876c.19523.19523.51177.19523.707,0l.35352-.35346c.19526-.19518.1953-.51171.00012-.70697-.00003-.00003-.00007-.00007-.00009-.00012Zm-11.15625-4.18841c-3.26274.00027-5.90794-2.64449-5.90821-5.90723-.00027-3.26274,2.64449-5.90794,5.90723-5.90821s5.90794,2.64449,5.90821,5.90723v.00098c-.00409,3.26078-2.64645,5.90314-5.90723,5.90723Z","fill":"var(--iconFill, #464646)"}));
}

SDCSearch22N.defaultProps = {"id":"ImportedIcons","width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = SDCSearch22N;

SDCSearch22N.default = SDCSearch22N;
